module.exports = __webpack_public_path__ + "img/1440.6514380c.jpg";